module.exports = __webpack_public_path__ + "static/jobMobile-013aa04c3134fcf98a4b6e6670527936.jpg";